import { jsx as _jsx } from "react/jsx-runtime";
export function Badge({ className = '', variant = 'default', ...props }) {
    const variantClasses = {
        default: 'bg-brand-100 text-brand-800',
        secondary: 'bg-gray-100 text-gray-800',
        success: 'bg-green-100 text-green-800',
        warning: 'bg-yellow-100 text-yellow-800',
        danger: 'bg-red-100 text-red-800',
    };
    return (_jsx("span", { className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]} ${className}`, ...props }));
}
